import { createSlice } from "@reduxjs/toolkit";

const bookingSlice = createSlice({
    name: "booking",
    initialState: {
        bookings :[],
        serviceData: [],
        bookingTimings: {
            serviceTiming: '',
            startDate: '',
        },
        totalPrice: 0,
    },
    reducers: {
        addBooking: (state, action) => {
            state.serviceData.push(action.payload.serviceData);
            state.bookingTimings = action.payload.bookingTimings;
        },
        resetBooking: (state) => {
            state.serviceData = [];
            state.bookingTimings = {};
        },
        feedBookings : (state,action)=>{
            state.bookings = action.payload;
        },
        resetBookings : (state)=>{
            state.bookings = [];
        }
    }
});

export const { addBooking, resetBooking,feedBookings,resetBookings } = bookingSlice.actions;
export default bookingSlice.reducer;